import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import {
  useEditQuizMutation,
  useGetSingleQuizQuery,
} from "../../../features/Quiz/quizApi";
import { useGetVideosQuery } from "../../../features/Videos/videosApi";
import routes from "../../../config/routeConfig";
import Error from "../../ErrorMessage";
import QuizForm from "./QuizForm";

const initialOptions = [
  { id: 1, option: "", isCorrect: true },
  { id: 2, option: "", isCorrect: false },
  { id: 3, option: "", isCorrect: false },
  { id: 4, option: "", isCorrect: false },
];

export default function EditQuizForm() {
  const navigate = useNavigate();
  const { quizId } = useParams();
  const [question, setQuestion] = useState("");
  const [options, setOptions] = useState(initialOptions);
  const [selectedVideo, setSelectedVideo] = useState(null);
  const { data: videos } = useGetVideosQuery();

  const {
    data: singleQuiz,
    isLoading,
    isSuccess: isGetSingleQuizSuccess,
    isError: isGetSingleQuizFailed,
  } = useGetSingleQuizQuery(+quizId);
  const [
    editQuiz,
    { isSuccess: isEditQuizSuccess, isError: isEditQuizFailed },
  ] = useEditQuizMutation();

  const handleSubmit = (e) => {
    e.preventDefault();

    const resultBody = {
      question: `${question}?`,
      video_id: selectedVideo.id,
      video_title: selectedVideo.title,
      options,
      id: +quizId,
    };

    editQuiz(resultBody);
  };

  useEffect(() => {
    if (isEditQuizSuccess) {
      setQuestion("");
      setOptions(initialOptions);
      navigate(routes.admin.quiz, { replace: true });
    } else if (isEditQuizFailed) {
      alert("Failed to edit quiz!");
    }
  }, [isEditQuizSuccess, isEditQuizFailed]);

  // set initial state
  useEffect(() => {
    if (isGetSingleQuizSuccess) {
      const { question, options, video_id } = singleQuiz;
      const selectedVideo = videos?.find((video) => video.id === video_id);

      setSelectedVideo(selectedVideo);
      setQuestion(question);
      setOptions(options);
    }
  }, [isGetSingleQuizSuccess, videos]);

  if (isLoading) return <div>Loading quiz data...</div>;
  if (isGetSingleQuizFailed) return <Error error="Failed to load quiz data!" />;

  return (
    <QuizForm
      isForEdit={true}
      handleSubmit={handleSubmit}
      question={question}
      setQuestion={setQuestion}
      options={options}
      setOptions={setOptions}
      setSelectedVideo={setSelectedVideo}
      selectedVideo={selectedVideo}
      videos={videos}
    />
  );
}
